export default[{
        path: '/invoices',
        name: 'invoices',
        component: () =>
            import ('@/views/pages/invoices/invoices-list/InvoicesList.vue'),
        meta: {
            pageTitle: 'Invoices',
            breadcrumb: [{
                text: 'Invoices',
                active: true,
                to: '/invoices'
            }],
            resource: 'invoice',
            action: 'read'
        }
    },
    {
        path: '/invoices/view/:id',
        name: 'invoices-view',
        component: () =>
            import ('@/views/pages/invoices/invoices-view/InvoicesView.vue'),
        meta: {
            pageTitle: 'View Invoice',
            breadcrumb: [
            {
                text: 'Invoices',
                to: '/invoices',
            },{
                text: 'View',
                active: true,
            } ],
            resource: 'invoice',
            action: 'read',
        },
    },
    {
        path: '/invoices/edit/:id',
        name: 'invoices-edit',
        component: () =>
            import ('@/views/pages/invoices/invoices-edit/InvoicesEdit.vue'),
        meta: {
            pageTitle: 'Edit Invoice',
            breadcrumb: [
            {
                text: 'Invoices',
                to:'/invoices',
            },
            {
                text: 'Edit',
                active: true,
            } ],
            resource: 'invoice',
            action: 'read',
        },
    },
    {
        path: '/invoices/add',
        name: 'invoices-add',
        component: () =>
            import ('@/views/pages/invoices/invoices-add/InvoicesAdd.vue'),
        meta: {
            pageTitle: 'Add Invoice',
            breadcrumb: [{
                text: 'Invoices',
                to: '/invoices',
            },
            {
                text: 'Add',
                active: true,
            } ],
            resource: 'invoice',
            action: 'read',
        }
    }
]